









import { Component, Vue } from "vue-property-decorator";
import BaseView from "@/components/Base/Elements/BaseView.vue";
import PreliminaryReport from "@/components/PreliminaryReport/PreliminaryReport.vue";

@Component({
  extends: BaseView,
  components: {
    PreliminaryReport
  }
})
export default class PreliminaryReportView extends Vue {}
